import script from "./PopulationLoad.vue?vue&type=script&setup=true&lang=js"
export * from "./PopulationLoad.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__